import { useQuery } from 'react-query';
import { getSupplyPositions, GetSupplyPositionsParams } from '../services/supplyService';
import { useAppSession } from '../contexts/AppSessionContext';

export const useSupplyPositions = (params: GetSupplyPositionsParams = {}) => {
  const { user } = useAppSession();
  const accountId = user?.accountId;
  
  return useQuery(
    ['supply-positions', accountId, params],
    () => getSupplyPositions({ ...params, accountId: accountId ? parseInt(accountId) : undefined }),
    {
      enabled: !!accountId,
      staleTime: 30000, // 30 seconds
      refetchOnWindowFocus: false,
    }
  );
};
